// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Cfmxbh","checkboxWrapperChecked":"z3VN3E","checkboxLabel":"GWM2dM"};